import type { FC } from 'react';
import Typography from '@mui/material/Typography';
import logo from './../../../assets/logo.svg';
import type { HotlinePageData } from '../../modules/algebra/global';

const TOSHeader: FC<{ pageData: HotlinePageData }> = ({ pageData }) => {
  const { clientLogo, title, subTitle, titleColor, subTitleColor, headerBgColor, headerBgImg, headerLogo } = pageData;
  return (
    <div className="flex py-4 px-4 md:px-4 items-center justify-between bg-no-repeat bg-cover bg-center" style={{ backgroundImage: `url(${headerBgImg})`, backgroundColor: headerBgColor }}>
      <div className="hotline-logo font-interbold text-6xl text-pc-1">
        <img className="w-auto md:h-full md:w-auto" src={headerLogo || clientLogo || logo} alt="Rainn Logo" />
      </div>
      <div className="flex justify-between md:w-full items-center pl-0 md:pl-4">
        <div className="hidden md:flex items-center">
          <Typography variant="body1" className="text-tc-5 text-2xl   px-0 md:px-5" style={{ color: titleColor, borderColor: titleColor }}>
            {title || `${process.env.NX_ORGANIZATION_NAME} Hotline`}
          </Typography>
          {subTitle && (
            <Typography variant="body1" className="px-5 text-lg text-tc-4 border-r-2 border-tc-5" style={{ color: subTitleColor }}>
              {subTitle}
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
};

export default TOSHeader;
